import { useMeasurementTypes } from "#src/contexts/MeasurementTypeContext";
import {
  DropdownInputBare,
  type DropdownProps,
} from "@validereinc/common-components";
import React from "react";

type MeasurementTypeDropdownInputBareProps = Omit<
  DropdownProps,
  "options" | "labelKey" | "valueKey"
> & {
  isLabelShown?: boolean;
};

/**
 * Uncontrolled Measurement Type dropdown using DropdownInputBare for use in FilterBuilder.
 * Loads all measurement types from the MeasurementType context as static options.
 * Value is controlled by parent (e.g. filter state); does not register with react-hook-form.
 */
export const MeasurementTypeDropdownInputBare = ({
  isLabelShown: _isLabelShown,
  ...props
}: MeasurementTypeDropdownInputBareProps) => {
  const { measurementTypes } = useMeasurementTypes();

  return (
    <DropdownInputBare
      options={measurementTypes}
      labelKey="name"
      valueKey="id"
      {...props}
    />
  );
};
